import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import Home from './pages/Home';
import Footer from './components/Footer';
import ServerSetupPage from './pages/ServerSetupPage';
import ServerMaintenancePage from './pages/ServerMaintenancePage';
import CloudSupportPage from './pages/CloudSupportPage';
import DatabaseManagementPage from './pages/DatabaseManagementPage';
import SoftwareDevelopmentPage from './pages/SoftwareDevelopmentPage';
import MobileAppDevelopmentPage from './pages/MobileAppDevelopmentPage';
import WebsiteDevelopmentPage from './pages/WebsiteDevelopmentPage';
import UIDesignPage from './pages/UIDesignPage';
import SEOPage from './pages/SEOPage';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<AboutPage />} />
            <Route path="/contact-us" element={<ContactPage />} />
            <Route path="/services/server-setup" element={<ServerSetupPage />} />
            <Route path="/services/server-maintenance" element={<ServerMaintenancePage />} />
            <Route path="/services/cloud-support" element={<CloudSupportPage />} />
            <Route path="/services/database-management" element={<DatabaseManagementPage />} />
            <Route path="/services/software-development" element={<SoftwareDevelopmentPage />} />
            <Route path="/services/mobile-app-development" element={<MobileAppDevelopmentPage />} />
            <Route path="/services/website-development" element={<WebsiteDevelopmentPage />} />
            <Route path="/services/ui-ux-design" element={<UIDesignPage />} />
            <Route path="/services/seo-optimization" element={<SEOPage />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
